(() => {
  if (customElements.get('lp-fitness-hero')) return;

  class LpFitnessHero extends HTMLElement {
    constructor() {
      super();
      this.measure = this.measure.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this._lastWidth = window.innerWidth;
      this.measure();
      window.addEventListener('resize', this.onResize);
      window.addEventListener('orientationchange', this.measure);
      window.addEventListener('load', this.measure);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('orientationchange', this.measure);
      window.removeEventListener('load', this.measure);
    }

    onResize() {
      // Ignore height-only resizes (iOS toolbar show/hide) to keep the banner stable.
      if (window.innerWidth === this._lastWidth) return;
      this._lastWidth = window.innerWidth;
      this.measure();
    }

    measure() {
      const header = document.querySelector('.site-header');
      const announcement = document.querySelector('.scrolling-announcement');
      const offset = (header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0);
      this.style.setProperty('--lpf-hero-offset', offset + 'px');

      // iOS Safari reports a smaller window.innerHeight while the toolbar is expanded,
      // which leaves the next section peeking. Use the (stable) layout viewport there.
      const ua = navigator.userAgent;
      const isIOSSafari =
        /iP(hone|od|ad)/.test(ua) && /Safari/.test(ua) && !/(CriOS|FxiOS|EdgiOS|OPiOS|GSA)/.test(ua);
      const viewportHeight = isIOSSafari ? document.documentElement.clientHeight : window.innerHeight;
      this.style.setProperty('--lpf-hero-height', (viewportHeight - offset) + 'px');
    }
  }

  customElements.define('lp-fitness-hero', LpFitnessHero);
})();
